const ExplainerTimeline = () => {
  const components = document.querySelectorAll('[data-component-explainer]');
  setTimeout(() => {
    components.forEach((component) => {
      const background = component.querySelector('[data-component-site-header-background]');
      const timeline = gsap.timeline({paused: true});
      const items = [];
      const imageWrapper = component.querySelector('.image-wrapper');
      const header = component.querySelector('.header');
      const copy = component.querySelector('.copy');
      const footer = component.querySelector('.footer');

      if (imageWrapper) items.push(imageWrapper);
      if (header) items.push(header);
      if (copy) items.push(copy);
      if (footer) items.push(footer);

      const groups = background.querySelectorAll('g');
      groups.forEach((group, index) => {
        const shapes = [].slice.call(group.querySelectorAll('polygon'));
        const reversedShapes = shapes.slice().reverse();
        timeline.fromTo(reversedShapes, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          ease: 'power3.out',
          duration: 0.5,
          stagger: 0.02,
        }, `shapes+=${Math.sqrt(index * 0.01)}`);
      });
      timeline.fromTo(items, {
        x: 40,
        opacity: 0,
      }, {
        x: 0,
        opacity: 1,
        duration: 0.7,
        stagger: 0.1,
        ease: 'power3.out'
      }, 0.3);
      setTimeout(() => {
        setupComponentReveal(component, timeline);
      }, 0);
    });
  }, 0);
};

ExplainerTimeline();